import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS = defineFcm('starter_experience_share_recommendations')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				experiment: { type: 'string' },
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		experiment: '',
	})
	.withMerger(({ countryValue, localeValue }) => {
		return {
			...countryValue,
			...localeValue,
			isEnabled: countryValue.isEnabled && localeValue.isEnabled,
		};
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Petition Dashboard',
		description:
			'If true, the users are treated into an A/B testing experiment to show AI generated sharing recommendations',
		mergeLogic: 'Displays in order of country then locale',
		import: false,
		template: {
			isEnabled: false,
			experiment: 'starter_experience_share_recommendations_v01',
		},
	});
